import { Component, Input } from '@angular/core';
import { Color, ScaleType } from '@swimlane/ngx-charts';
import { curveCardinal } from 'd3-shape';

@Component({
    selector: 'app-res-rgb-chart',
    templateUrl: './res-rgb-chart.component.html',
    styleUrl: './res-rgb-chart.component.scss',
    standalone: false
})
export class ResRgbChartComponent {
	@Input() rgbData: any[] = [];

	chartData: any[] = [
		{ name: 'Cognitive', series: [] },
		{ name: 'Emotion', series: [] },
	];

	curve: any = curveCardinal;

	legend = false;
  animations = false;
  autoScale = false;
  showGridLines = true;
  roundDomains = false;
  xAxis = true;
  yAxis = true;
  showYAxisLabel = true;
  showXAxisLabel = true;
	min = 0;
	max = 100;
	colorScheme: string | Color = {
		name: 'myScheme',
		selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#15A607', '#F1D50A', '#F11C0A'],
  };

	ready = false;

	videoTime = '00:00';

	lastCog = 0;
	lastEmo = 0;

	calculateChartData(currentTime: number) {
		const start = currentTime - 20;
		const dataChart: any = [
			{ name: 'Cognitive', series: [] },
			{ name: 'Emotion', series: [] },
		];

		for (let index = start; index <= currentTime; index++) {
			const time = this.convertToTimerFormat(index);

			let cog;
			let emo;

			if (index < this.rgbData.length) {
				cog = +(this.rgbData[index].cognitive);
				emo = +(this.rgbData[index].emotional);

				this.lastCog = cog;
				this.lastEmo = emo;
			} else {
				cog = this.lastCog;
				emo = this.lastEmo;
			}

			dataChart[0].series.push({ name: time, value: cog });
			dataChart[1].series.push({ name: time, value: emo });
		}

		this.chartData = [...dataChart];

		
		if (!this.ready) {
			this.ready = true;
		}
	}

	findTickTime() {
		const ticks = document.getElementsByClassName('tick');

		if (ticks.length > 0) {
			for (let index = 0; index < ticks.length; index++) {
				if (document.getElementsByClassName('tick')[index].childNodes[0].textContent === this.videoTime) {
					const inputString = document.getElementsByClassName('tick')[index].attributes[1].value;

					const pattern = /translate\((\d+\.\d+),\d+\)/;
					const match: RegExpExecArray | null = pattern.exec(inputString);
					
					if (match) {
						const result: number = parseFloat(match[1]);
						const elList = document.getElementsByClassName('tooltip-anchor')[0].attributes.getNamedItem('x');
						if (elList) {
							elList.nodeValue = result.toString();
						}
					}
				}
				break;
			}
		}
	}

	updateChart(currentTime: number) {
		this.videoTime = this.convertToTimerFormat(currentTime);
		if (currentTime > 20) {
			this.calculateChartData(currentTime);
		} else {
			this.calculateChartData(20);
		}
	}

	showChart() {
		this.ready = true;
		this.calculateChartData(20);
	}

	convertToTimerFormat(seconds: number) {
		if (seconds < 3600) {
			// Display "mm:ss" format for the first 60 minutes
			const minutes = Math.floor(seconds / 60);
			const formattedSeconds = (seconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			return `${formattedMinutes}:${formattedSeconds}`;
		} else {
			// After 60 minutes, switch to "hh:mm:ss" format
			const hours = Math.floor(seconds / 3600);
			const remainingSeconds = seconds % 3600;
			const minutes = Math.floor(remainingSeconds / 60);
			const formattedSeconds = (remainingSeconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			const formattedHours = hours.toString().padStart(2, "0");
			return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
		}
	}
}
